<template>
	<div>
		<div id="myCourses" class="my-courses py-4">
			<div class="main container clearfix py-3">
				<h3 id="courseTitle" class="i-title"><a class="myCoursePoint" href="javascript:void(0)" @click="totest()">考试测评</a>&nbsp;&nbsp;&gt;&nbsp;&nbsp;{{teachSubject.subjectNamejc}}</h3>
				<div class="content clearfix">
					<div class="left"><img :src="teachSubject.subjectPic" class="img-thumbnail"></div>
					<div class="right">
						<div class="top">
							<h3>{{teachSubject.subjectNamejc}}</h3>
							<p>{{teachSubject.subjectDesc}}</p>
							<div>
								<p class="tips"><span class="meta">章节</span><span class="meta-value"><strong>{{teachSubject.subjectTag.split(",")[0]}}</strong></span><em>·</em><span class="meta">真题</span><span class="meta-value"><strong>{{teachSubject.subjectTag.split(",")[1]}}</strong></span><em>·</em><span class="meta">试题</span><span class="meta-value"><strong>{{teachSubject.subjectTag.split(",")[2]}}</strong></span></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="coursesInfo" class="courses-info py-5">
			<div class="main container clearfix py-2">
				<div id="coursesInfoContent" class="content clearfix">
					<h3 class="heading mb-4 mt-3 ml-2 pl-1">专项测评</h3>
					<p class="htitle ml-2 pl-1">理论与实操结合，相辅相成</p>
					<div class="course-floor clearfix">
						<div class="card" v-for="(item,key) of teachSubject.chapterList" :key="item.id" v-if="item.chapterNamecp">
							<a href="javascript:void(0)" class="card-course is-auth" @click="dotest(item.id)">
								<div class="card-course-top hashadow"><img :src="item.chapterPic" class="course-banner"></div>
								<div class="course-card-content">
									<h3 class="course-card-name">{{item.chapterNamecp}}</h3>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TeachCourseContent',
		props: ["teachSubject"],
		data() {
			return {
				teachSubject: []
			}
		},
		methods: {
			dotest(cid) {
				if(this.$store.state.loginFlag) {
					this.$router.push({
						path: '/robot/test/dochapter?cid=' + cid
					})
				} else {
					header.methods.login()
				}
			},
			totest() {
				this.$router.push({
					path: '/robot/test'
				})
			}
		},
		mounted() {}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/teach/components/TeachCourseContent.scss';
</style>